import {Command, TextSelection, EditorState, Transaction} from "prosemirror-state";
import {NodeType} from "prosemirror-model";


export const insertHardBreak: Command = (state:EditorState, dispatch) => {
		const brType = state.schema.nodes.br;
		if (!brType) return false;
		if (dispatch) {
			const tr = state.tr;
			tr.replaceSelectionWith(brType.create());
			dispatch(tr.scrollIntoView());
		}
		return true;
	};

export const insertHorizontalRule: Command = (state:EditorState, dispatch) => {
		const hrType = state.schema.nodes.hr;
		if (!hrType) return false;
		if (dispatch) {
			const tr = state.tr;
			tr.replaceSelectionWith(hrType.create());
			dispatch(tr.scrollIntoView());
		}
		return true;
	};
